import { render, staticRenderFns } from "./receiver_categories.vue?vue&type=template&id=4ac2a9e0&scoped=true&"
import script from "./receiver_categories.vue?vue&type=script&lang=js&"
export * from "./receiver_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac2a9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac2a9e0')) {
      api.createRecord('4ac2a9e0', component.options)
    } else {
      api.reload('4ac2a9e0', component.options)
    }
    module.hot.accept("./receiver_categories.vue?vue&type=template&id=4ac2a9e0&scoped=true&", function () {
      api.rerender('4ac2a9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/privat/receiver_categories.vue"
export default component.exports